// src/components/FilterSheet.js
// Session 16 — bottom-sheet modal for filter changes on stats pages.
// Used by Records, Leaderboards, Banana, H2H collapsed-bar "Change" buttons.
//
// Behavior:
// - Tap outside → closes
// - X button (top-right) → closes
// - Live apply: whatever child filters emit (chips, tabs) fires through to parent state;
//   the parent re-fetches on change. Modal stays open.
//
// Usage:
//   <FilterSheet open={open} onClose={() => setOpen(false)} title="Filters">
//     {child content — your YearChips, tabs, Active Only, etc.}
//   </FilterSheet>

import React from 'react';

export function FilterSheet({ open, onClose, title = 'Filters', children }) {
  if (!open) return null;
  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 200,
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
      }}>
      <div style={{
        background: 'white', borderRadius: '18px 18px 0 0',
        width: '100%', maxWidth: 560,
        maxHeight: '85vh', overflowY: 'auto',
        padding: '10px 18px calc(18px + env(safe-area-inset-bottom, 0px))',
      }}>
        {/* Drag handle */}
        <div style={{ width: 40, height: 4, background: '#e5e7eb', borderRadius: 2, margin: '6px auto 10px' }} />
        {/* Title + close */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
          <div style={{ fontFamily: 'Rajdhani,sans-serif', fontWeight: 800, fontSize: '1rem', color: '#1E3A6E' }}>
            {title}
          </div>
          <button onClick={onClose}
            style={{ background: '#f3f4f6', border: 'none', width: 32, height: 32, borderRadius: 16,
              fontSize: '1rem', cursor: 'pointer', color: '#6b7280' }}>
            ✕
          </button>
        </div>
        <div>
          {children}
        </div>
      </div>
    </div>
  );
}

export default FilterSheet;
